// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#e4bb4d","subMenuActiveText":"#e4bb4d","menuBg":"#353535","menuHover":"#5d5d5d","subMenuBg":"#424242","subMenuHover":"#5d5d5d","sideBarWidth":"240px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 125